import React, { memo } from 'react';
import { Item } from 'components/TreatmentPlan';
import { PortalSpinner } from 'components/PortalSpinner';
import InfiniteScroll from 'react-infinite-scroll-component'

const List = ({ treatmentPlans, loadMore, pageEnd }) => {
  if (!treatmentPlans)
    return <PortalSpinner />

  if (treatmentPlans.length == 0)
    return <div className="py-6 text-center text-sm text-secondary-400">No treatment plans found.</div>

  return (
    <InfiniteScroll
      dataLength={treatmentPlans.length}
      next={loadMore}
      hasMore={!pageEnd}
      loader={<div className="col-span-full flex justify-center py-3"><PortalSpinner /></div>}
      className="grid grid-cols-1 lg:grid-cols-2 gap-4"
    >
      {treatmentPlans.map((item) => <Item key={item.id} data={item} />)}
    </InfiniteScroll>
  );
};

const areEqual = (prevProps, nextProps) => {
  return prevProps.treatmentPlans === nextProps.treatmentPlans &&
    prevProps.pageEnd === nextProps.pageEnd
};

export default memo(List, areEqual);
